const commonUrl = "api/v1/eklink"

const apiEndPoints = {
  getCountryMetaData: `${commonUrl}/user/auth/metadata`,
  signUpMetaData: `${commonUrl}/user/signUp/metadata`,

  countryMetaData: `${commonUrl}/generic/countryMetadata`,
  administrativeLevelMetadata: `${commonUrl}/generic/administrative-level`,
  stateMetaData: `${commonUrl}/generic/stateMetadata`,
  districtMetaData: `${commonUrl}/generic/districtMetadata`,
  blockMetaData: `${commonUrl}/generic/blockMetadata`,
  postalCodeLookup: `${commonUrl}/generic/postal-lookup`,
  validatePromoCode: `${commonUrl}/generic/promo-code/validate`,
  subscriptionMetaData: `${commonUrl}/user/signUp/subscription`,
  signUpInitiativeMetaData: `${commonUrl}/user/signUp/countryBasedMetadata`, // Appends countryId as path parameter in login.service
  integrators: `${commonUrl}/user/signUp/integrators`, // Appends countryId as path parameter in login.service
  financialSupportPlans: `${commonUrl}/financial-support/plans`, // Financial support plans from pricing module via eK Link BFF

  initiativeMetaData: `${commonUrl}/dare/initiative/metadata`,
  initiativeData: `${commonUrl}/dare/initiative`,
  agentCreation: `${commonUrl}/dare/agent`,
  genderMetadata: `${commonUrl}/generic/genderMetadata`,
  getAllAgent: `${commonUrl}/dare/agent`,
  downloadExcelAgent: `${commonUrl}/dare/agent`,
  downloadPdfAgent: `${commonUrl}/dare/agent`,
  agentGetById: `${commonUrl}/dare/agent`,
  agentApproval: `${commonUrl}/dare/agent`,

  farmerMetaData: `${commonUrl}/dare/farmer/metadata`,
  farmerCreation: `${commonUrl}/dare/farmer`,

  getAllManageFarmer: `${commonUrl}/dare/farmer/manageFarmer`,
  manageFarmerMetaData: `${commonUrl}/dare/farmer/manageFarmerMetadata`,
  manageFarmerApproval: `${commonUrl}/dare/farmer/manageFarmer`,

  getAllFarmerPortfolio: `${commonUrl}/dare/farmer/farmerPortfolioList`,
  farmerPortfolioDetails: `${commonUrl}/dare/farmer/farmerdetails`,
};

export default apiEndPoints;